
import { UITranslations } from '../types/ui';

export const ui: UITranslations = {
  'cancel': 'Cancel',
  'loading': 'Loading...',
  'success': 'Success',
  'completed': 'Completed',
  'pending.completion': 'Pending completion',
  'messages': 'Messages',
  'support': 'Support',
  'copy': 'Copy',
  'display.name': 'Display Name',
  'profile.upload.photo': 'Upload Photo',
  'link.to.removal': 'Link to removal page',
  'link.remove': 'Remove',
  'subscription.active': 'Active',
  'subscription.1month': '1 Mo',
  'subscription.3months': '3 Mo',
  'subscription.6months': '6 Mo',
  'subscription.12months': '12 Mo',
  'subscription.24months': '24 Mo',
  'subscription.none': 'No Plan',
  'subscription.select': 'Select Plan',
  'subscription.tooltip.1month': 'Monthly plan',
  'subscription.tooltip.3months': 'Quarterly plan',
  'subscription.tooltip.6months': 'Six month plan',
  'subscription.tooltip.12months': 'Annual plan',
  'subscription.tooltip.24months': 'Bi-annual plan',
  'privacy': 'Privacy Policy',
  'license': 'License Terms',
  'terms': 'Terms of Use',
  'notifications': 'Notifications',
  'notifications.title': 'Notifications',
  'notifications.mark.all.read': 'Mark all as read',
  'notifications.empty': 'No notifications',
  'profile.manage': 'Manage Profile',
  'profile.billing': 'Billing',
  'profile.settings': 'Settings',
  'profile.signing.out': 'Signing out...',
  'profile.sign.out': 'Sign out',
  'search.placeholder': 'Search...',
  'search.customers.placeholder': 'Search name, email or UID',
  'search.no.results': 'No results found',
  'search.category.pages': 'Pages',
  'search.category.settings': 'Settings',
  'settings.success': 'Success',
  'settings.notifications.updated': 'Notification settings updated',
  'settings.email.notifications': 'Email Notifications',
  'settings.email.notifications.description': 'Receive notifications via email',
  'settings.inapp.notifications': 'App Notifications',
  'settings.inapp.notifications.description': 'Receive notifications in the app',
  'settings.change.password': 'Change Password',
  'settings.password.updated': 'Password updated',
  'settings.notification.preferences': 'Notification preferences',
  'settings.email.monitoring': 'Monitoring',
  'settings.email.deindexing': 'Deindexing',
  'settings.email.address.alerts': 'Address Alerts',
  'settings.email.news': 'News',
  'success.avatarUpdated': 'Profile photo updated',
  'success.avatarDeleted': 'Profile photo deleted',
  'error.avatarDelete': 'Failed to delete profile photo',
  'toast.copied.title': 'Copied',
  'toast.copied.description': 'Text copied to clipboard',
  'overview.welcome': 'Welcome to your dashboard',
  'current.password': 'Current Password',
  'set.password.description': 'Set a secure password for your account',
  'profile': 'Profile',
  'delete': 'Delete',
  'save': 'Save',
  'upload': 'Upload',
  'password.updated.successfully': 'Password updated successfully',
  'password.update.error': 'Failed to update password',
  'total.customers': 'Customers',
  'view.all.columns': 'All columns',
  'toggle.columns': 'Select columns to show',
  'add.customer': 'Add Customer',
  'no.customers': 'No customers online',
  'name': 'Name',
  'email': 'Email',
  'address': 'Address',
  'checklist': 'Checklist',
  'last.online': 'Last Online',
  'plan': 'Plan',
  'in.progress': 'In Progress',
  'online': 'Online',
  'offline': 'Offline',
  'last.seen': 'Last seen: ',
  'no.name': 'No name',
  'no.email': 'No email',
  'no.plan': 'No plan',
  'search.global': 'Search...',
  'sort.descending': 'Sort descending',
  'sort.ascending': 'Sort ascending',
  'account.details': 'Account Details',
  'customer.id': 'Customer ID',
  'created': 'Created',
  'status': 'Status',
  'url.submissions': 'URL Submissions',
  'total.urls': 'Total URLs',
  'url.count': 'Count',
  'url.limit': 'Limit',
  'onboarding.status': 'Onboarding Status',
  'current.step': 'Current Step',
  'not.available': 'N/A',
  'urls.available': 'URLs Available',
  'progress': 'Progress',
  'steps': 'steps',
  'pagination.of': 'of',
  'pagination.pages': 'pages',
  'pagination.next': 'Next',
  'pagination.previous': 'Previous',
  'pagination.page': 'Page',
  'pagination.items.per.page': 'Items per page',
  'pagination.total.items': 'Total items',
  'private.customers': 'Private Customers',
  'business.customers': 'Business Customers',
  'subscription.period.1month': '1 month:',
  'subscription.period.6months': '6 months:',
  'subscription.period.12months': '12 months:',
  'subscription.period.24months': '24 months:',
  'online.users': 'Customers Online',
  'link.management': 'Link Management',
  'total.links': 'Total Links',
  'pending.links': 'Pending Links',
  'subscription.distribution': 'Subscription Distribution',
  'customers': 'Customers',
  'timerange.alltime': 'All Time',
  'timerange.ytd': 'Year to Date',
  'timerange.mtd': 'Month to Date',
  'timerange.1year': '1 Year',
  'timerange.4weeks': '4 Weeks',
  'timerange.1week': '1 Week',
  'version.log.title': 'Version Log',
  'warning': 'Warning',
  'warning.admin.notification': 'Could not notify admin about this change',
  'notification.status.update.title': 'Link status updated',
  'notification.status.update.message': 'The process has progressed for one or more of your links. Log in to your account to see more.',
  'deindexing.title': 'Links',
  'deindexing.need.more': 'Need more URLs?',
  'unlimited': 'Unlimited',
  'customer.type': 'Customer Type',
  'subscription': 'Subscription',
  'updating': 'Updating...',
  'update': 'Update',
  'success.email_sent': 'Email Sent',
  'success.activation_email_sent': 'Activation email has been sent',
  'success.updated': 'Updated',
  'success.url_limits_updated': 'URL limits updated successfully',
  'success.subscription_updated': 'Subscription updated successfully',
  'success.deleted': 'Deleted',
  'success.user_deleted': 'User has been deleted successfully',
  'create.customer': 'Create Customer',
  'create.customer.description': 'Add a new customer to the platform. Fill in their details below.',
  'create.with.email': 'Create & Send Welcome Email',
  'create.without.email': 'Create Without Email',
  'creating': 'Creating...',
  'address.alert': 'Address Alert',
  'private.customer': 'Private Customer',
  'business.client': 'Business Client',
  'select.address.alert': 'Select address alert',
  'select.customer.type': 'Select customer type',
  'select.subscription.plan': 'Select subscription plan',
  '1.month': '1 Month',
  '3.months': '3 Months',
  '6.months': '6 Months',
  '12.months': '12 Months',
  '24.months': '24 Months',
  'mrkoll.not.checked': 'Not yet',
  'monitoring.url.added': 'URL has been added for monitoring',
  'monitoring.url.updated': 'URL status has been updated successfully',
  'monitoring.url.approved': 'URL approved and moved to link management',
  'monitoring.url.rejected': 'URL rejected',
  'monitoring.url.error.approve': 'Failed to approve URL',
  'monitoring.url.error.reject': 'Failed to reject URL',
  'error': 'Error',
  'url.input.placeholder': 'Enter link',
  'monitoring.add.new': 'Add new',
  'monitoring.links': 'Links',
  'appearance': 'Appearance',
  'light.mode': 'Light mode',
  'dark.mode': 'Dark mode',
};
